<template>
  <div class="top-emotions-card">
    <div
        v-if="warning"
        class="top-emotions-card__warning"
    >
      <ExclamationCircleFilled class="top-emotions-card__warning-icon" />

      <div>
        <div>
          <strong>{{ warning.text }}</strong>
        </div>

        <ol
            v-if="warning.recommendations && warning.recommendations.length"
            class="top-emotions-card__recommendations"
        >
          <li
              v-for="recommendation in warning.recommendations"
              :key="recommendation"
          >
            {{ recommendation }}
          </li>
        </ol>
      </div>
    </div>

    <div class="top-emotions-card__list">
      <div
          v-for="(item, index) in normalizedItems"
          :key="item.name"
          class="top-emotions-card__row"
          :class="{ 'top-emotions-card__row--muted': !item.highlighted }"
      >
        <div class="top-emotions-card__name">
          <span>№ {{ index + 1 }}.</span>
          <span>{{ item.name }}</span>
        </div>

        <span
            class="top-emotions-card__change"
            :class="{
              'positive-change': item.change > 0,
              'negative-change': item.change < 0,
              'neutral-change': item.change === 0
            }"
        >
          {{ getChangeText(item.change) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { ExclamationCircleFilled } from '@ant-design/icons-vue'

export default {
  name: 'TopEmotionsCard',

  components: {
    ExclamationCircleFilled,
  },

  props: {
    warning: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const normalizedItems = computed(() => {
      return props.items.map((item) => {
        const change = Number(item.change)

        return {
          ...item,
          change: Number.isFinite(change) ? change : 0,
          highlighted: Boolean(item.highlighted),
        }
      })
    })

    const getChangeText = (value) => {
      if (value > 0) {
        return `↑ ${value}%`
      }

      if (value < 0) {
        return `↓ ${Math.abs(value)}%`
      }

      return '–'
    }

    return {
      normalizedItems,
      getChangeText,
    }
  },
}
</script>

<style scoped lang="scss">
.top-emotions-card {
  width: 100%;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  text-align: start;
}

.top-emotions-card__warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 78px;
  padding: 12px 16px;
  border-radius: 4px;
  background: #FFF8E1;
  font-size: 16px;
  line-height: 130%;
  color: rgba(0, 0, 0, 0.88);
}

.top-emotions-card__warning-icon {
  margin-top: 3px;
  color: #FAAD14;
  font-size: 16px;
}

.top-emotions-card__recommendations {
  margin: 2px 0 0;
  padding-left: 22px;
}

.top-emotions-card__list {
  display: flex;
  flex-direction: column;
}

.top-emotions-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 49px;
  border-bottom: 1px solid #EEF0F3;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.top-emotions-card__row:first-child {
  border-top: none;
}

.top-emotions-card__row--muted {
  color: rgba(0, 0, 0, 0.45);
}

.top-emotions-card__name {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  font-weight: 600;
}

.top-emotions-card__change {
  flex: 0 0 auto;
  font-weight: 400;
  white-space: nowrap;
}

.positive-change {
  color: var(--main-green);
}

.negative-change {
  color: #F55565;
}

.neutral-change {
  color: rgba(0, 0, 0, 0.45);
}
</style>